"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));

var _classPrivateFieldLooseBase2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseBase"));

var _classPrivateFieldLooseKey2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classPrivateFieldLooseKey"));

var _utils = require("@package/utils");

var _events = /*#__PURE__*/(0, _classPrivateFieldLooseKey2["default"])("_events");

var Base = /*#__PURE__*/function () {
  function Base() {
    (0, _classCallCheck2["default"])(this, Base);
    Object.defineProperty(this, _events, {
      writable: true,
      value: new _utils.Events()
    });
  }

  (0, _createClass2["default"])(Base, [{
    key: "events",
    get: function get() {
      return (0, _classPrivateFieldLooseBase2["default"])(this, _events)[_events];
    }
  }]);
  return Base;
}();

var _default = Base;
exports["default"] = _default;